import React from 'react'
import Navbar from '../layouts/Navbar'
import Footer from '../Footer'

const Mac = () => {
    return (
        <div>
            <Navbar />
            Mac
            <Footer />
        </div>
    )
}

export default Mac
